var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDocumentDoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "24px",
    viewBox: "0 0 20 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "budicon-file") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Application_Screening_Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lease-Details",
    transform: "translate(-863.000000, -892.000000)",
    fill: "#22212A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "budicon-file",
    transform: "translate(863.000000, 892.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2522667,1.64352 L18.2641778,6.72 L13.7443556,6.72 C13.4836148,6.72 13.2712296,6.50592 13.2702815,6.24192 L13.2522667,1.64352 L13.2522667,1.64352 Z",
    id: "Shape",
    opacity: 0.200000003
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.31851852,21.12 C3.05682963,21.12 2.84444444,20.90496 2.84444444,20.64 L2.84444444,0.96 L1.42222222,0.96 C1.16053333,0.96 0.948148148,1.17504 0.948148148,1.44 L0.948148148,22.56 C0.948148148,22.82496 1.16053333,23.04 1.42222222,23.04 L18.4888889,23.04 C18.7505778,23.04 18.962963,22.82496 18.962963,22.56 L18.962963,21.12 L3.31851852,21.12 L3.31851852,21.12 Z",
    id: "Shape",
    opacity: 0.200000003
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4948741,6.60864 L13.3869037,0.42144 C13.1204741,0.15168 12.7582815,0 12.3809185,0 L1.42222222,0 C0.637155556,0 0,0.64416 0,1.44 L0,22.56 C0,23.35584 0.637155556,24 1.42222222,24 L18.4888889,24 C19.2739556,24 19.9111111,23.35584 19.9111111,22.56 L19.9111111,7.62624 C19.9111111,7.24512 19.7613037,6.87936 19.4948741,6.60864 L19.4948741,6.60864 Z M18.2641778,6.72 L13.7443556,6.72 C13.4836148,6.72 13.2712296,6.50592 13.2702815,6.24192 L13.2522667,1.64352 L18.2641778,6.72 L18.2641778,6.72 Z M18.962963,22.56 C18.962963,22.82496 18.7505778,23.04 18.4888889,23.04 L1.42222222,23.04 C1.16053333,23.04 0.948148148,22.82496 0.948148148,22.56 L0.948148148,1.44 C0.948148148,1.17504 1.16053333,0.96 1.42222222,0.96 L12.3022222,0.96 L12.3221333,6.24576 C12.3249778,7.0368 12.9630815,7.68 13.7443556,7.68 L18.962963,7.68 L18.962963,22.56 L18.962963,22.56 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.74074074,14.88 C4.74074074,15.14496 4.95312593,15.36 5.21481481,15.36 L14.6962963,15.36 C14.9579852,15.36 15.1703704,15.14496 15.1703704,14.88 C15.1703704,14.61504 14.9579852,14.4 14.6962963,14.4 L5.21481481,14.4 C4.95312593,14.4 4.74074074,14.61504 4.74074074,14.88 L4.74074074,14.88 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.21481481,11.52 L10.9037037,11.52 C11.1653926,11.52 11.3777778,11.30496 11.3777778,11.04 C11.3777778,10.77504 11.1653926,10.56 10.9037037,10.56 L5.21481481,10.56 C4.95312593,10.56 4.74074074,10.77504 4.74074074,11.04 C4.74074074,11.30496 4.95312593,11.52 5.21481481,11.52 L5.21481481,11.52 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6962963,18.24 L5.21481481,18.24 C4.95312593,18.24 4.74074074,18.45504 4.74074074,18.72 C4.74074074,18.98496 4.95312593,19.2 5.21481481,19.2 L14.6962963,19.2 C14.9579852,19.2 15.1703704,18.98496 15.1703704,18.72 C15.1703704,18.45504 14.9579852,18.24 14.6962963,18.24 L14.6962963,18.24 Z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocumentDoc);
export default __webpack_public_path__ + "static/media/icon-document-doc.9305b704aa343077e2abe78e7b0372f9.svg";
export { ForwardRef as ReactComponent };